import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { RouterService } from '../../services/router.service';
import { FrontSettingsService } from '../../services/front-settings.service';
import { FRONTSETTINGS } from '../../interfaces/front-settings.interface';
import { MyAccountService } from '../../services/my-account.service';
import { OrderHistoryService } from '../../services/order-history.service';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent {
  isSidebarOpen = false;
  enableButtonBack = false;
  showSideBar = false;
  allowedRoutes = ['/', '/home', '/'];
  frontSettings: FRONTSETTINGS = {}

  showPopup = false;

  isAuthChecked = false;
  showModalSession = false;
  enableSidebar = false;
  country = "";
  showNavbar: boolean = true;
  isHomeComponent: boolean = true;
  isHistoryComponent: boolean = false;



  constructor(
    private router: Router,
    private _routerService: RouterService,
    private _frontSettingsService: FrontSettingsService,
    public _myAccountService: MyAccountService,
    private _orderHistoryService: OrderHistoryService,
    private _route: ActivatedRoute
  ) {
    this.allowedRoutes = ['/', '/home', '/' + _routerService.getCountry()];

    this._route.paramMap.subscribe(params => {
      this.country = params.get('country')!;
      this._routerService.setCountry(this.country);

      this.router.events.pipe(
        filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
        this.checkShowNavBar();
        this.checkShowHistoryButton();

      });
      this.checkShowNavBar();
      this.checkShowHistoryButton();
    });
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.enableControls();
      }
    });
    this.enableControls();

    this._frontSettingsService.frontSettings$.subscribe(frontSettings => {
      this.frontSettings = frontSettings
    });

    this.isAuthChecked = this._myAccountService.isAutenticated();
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar() {
    this.isSidebarOpen = false;
  }

  enableControls() {
    this.enableButtonBack = !this.allowedRoutes.includes(this.router.url);
  }

  openModalSession(): void {
    this.showModalSession = true;
  }

  onCancel(): void {
    this.showModalSession = false;
  }

  onConfirm(): void {
    this.showModalSession = false;
    this.logout();
  }

  logout() {
    this._myAccountService.logout();
    this.router.navigate(['/'], { replaceUrl: true });
    this._orderHistoryService.clearHistoryOrders();
  }

  checkLogin() {
    if (this._myAccountService.isAutenticated()) {
      this.openModalSession();
    } else {
      this.router.navigate(["/my-account"])
    }
  }

  pageBack() {
    history.back();
  }

  togglePopup() {
    this.showPopup = !this.showPopup;
  }

  toggleTitle(show: boolean) {
    this.showPopup = !show;
  }

  checkShowHistoryButton() {
    if (this.router.url == `/${this.country}/order-history`) {
      this.isHistoryComponent = true;
    } else {
      this.isHistoryComponent = false;
    }
  }

  checkShowNavBar() {
    if (this.router.url == `/${this.country}` || this.router.url == `/${this.country}/home`) {
      this.showNavbar = false;
      this.isHomeComponent = true;
    } else {
      this.showNavbar = true;
      this.isHomeComponent = false;
    }
  }

}
